import Vue from 'vue'
import repository from '@/repositories/Repository'

// 各コンポーネントからアクセスするときの名前登録（テンプレ）
Vue.mixin({
  beforeCreate() {
    const options = this.$options
    if (options.customerGroup) this.$customerGroup = options.customerGroup
    else if (options.parent && options.parent.$customerGroup)
      this.$customerGroup = options.parent.$customerGroup
  },
})

export default {
  /**
   * ファイルアップロードにより一時顧客グループを作成する
   */
  async upload(file) {
    const formData = new FormData()
    formData.append('file', file)

    try {
      const response = await repository.giggle.post(
        `/api/customer-group/upload`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
      )

      return response.data
    } catch (error) {
      if (error.response.status === 400) {
        return {
          invalidFile: true,
        }
      }
      throw error
    }
  },
  /**
   * 条件指定により一時顧客グループを作成する
   */
  create(queryId, queryFragments) {
    return repository.giggle
      .post(`/api/customer-group/create/${queryId}`, queryFragments)
      .then(r => r.data)
  },
  /**
   * 指定顧客グループのダウンロードURLを取得する
   */
  archive(customerGroupId) {
    return repository.giggle
      .get(`/api/customer-group/archive/${customerGroupId}`)
      .then(r => r.data)
  },
  /**
   * 2つの顧客グループから新しい顧客グループを作成する
   */
  createFromCustomerGroupIds(customerGroupId1, customerGroupId2, areas) {
    return repository.giggle
      .get(
        `/api/customer-group/venn?customerGroupId1=${customerGroupId1}&customerGroupId2=${customerGroupId2}&${areas
          .map(a => 'types=' + a)
          .join('&')}`,
      )
      .then(r => r.data)
  },
}
